import script from "./UiCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCard.vue?vue&type=script&setup=true&lang=js"

import "./UiCard.vue?vue&type=style&index=0&id=4b6bacde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6bacde"]])

export default __exports__